import _ from "lodash";
import { paymentDispatcher } from "../../../actions/book/payment";
import { createFlightBooking } from "../../../api";
import { sendPixelEvent } from "../../../helpers";
import { getExchangedPrice } from "../../../umbilical_hocs";

var website_api_key = import.meta.env.VITE_APP_WEBSITE_KEY;

export const emptyFields = {
  title: "",
  first_name: "",
  last_name: "",
  id_type: "",
  id_passport_code: "",
  expiration_date: "",
  frequent_flyer_number: "",
  frequent_flyer_airline: "",
  date_of_birth: "",
  nationality: "",
  gender: "",
  phone: "",
  email: "",
  group_leader: false,
};

export const requiredFieldsFlights = {
  adults: [
    "title",
    "first_name",
    "last_name",
    "phone",
    "email",
    "date_of_birth",
  ],
  children: ["first_name", "last_name", "date_of_birth", "date_of_birth"],
};
export const requiredInternationalFielssFls = {
  adults: ["id_type", "id_passport_code", "expiration_date"],
  children: ["id_type", "id_passport_code", "expiration_date"],
};

export function checkIfInternationalFl(searchForm) {
  return (
    _.get(searchForm, "origin.origin_meta.0.country_code", "a") !==
    _.get(searchForm, "destination.destination_meta.0.country_code", "b")
  );
}

export function initPayment({
  customer_user_data,
  page_session_id,
  settedCurrency,
  dispatch,
  source_entity,
  amount,
  currency,
  reference,
  inbound_uid,
  outbound_uid,
  customer_stripe_id,
}) {
  const newPrice = getExchangedPrice({
    price: amount,
    priceCurrency: currency,
    settedCurrency,
  });
  const booking_reference = reference;
  const srv_type = "FL";
  const order_id = `${srv_type}___${booking_reference}`;

  const base_url = window.location.origin;
  const success_url = `${base_url}/flights/successful-booking/${page_session_id}`;
  const cancel_url = `${base_url}/flights/booking_process/${page_session_id}?outbound=${outbound_uid}${
    inbound_uid ? "&inbound=" + inbound_uid : ""
  }`;
  const fail_url = `${base_url}/failed-booking/${page_session_id}`;

  sendPixelEvent("InitiateCheckout", {
    data: { product_type: "flight" },
    withPageView: false,
  });

  const {
    first_name,
    last_name,
    guest_uuid: customer_uid,
    nationality,
    email,
  } = customer_user_data;

  dispatch(
    paymentDispatcher({
      booking_reference,
      page_session_id,
      amount: newPrice,
      currency: settedCurrency,
      first_name,
      last_name,
      email,
      customer_uid,
      nationality,
      customer_stripe_id,
      order_id,
      success_url,
      cancel_url,
      fail_url,
      srv_type,
      source_entity,
    })
  );
}

export async function onCreateFlightBooking({
  search_session_id,
  guests,
  flight,
  customer_user_data,
  website_name,
  origin_meta,
  destination_meta,
  page_session_id,
  settedCurrency,
  customer_stripe_id,
  source_entity,
  dispatch,
  history,
}) {
  const total_price = flight.selectedFlight.price.total_price;
  var currency = flight.selectedFlight.price.currency;

  const bookingResult = await createFlightBooking({
    payload: {
      session_id: search_session_id,
      guests,
      flight,
      customer_user_data,
      website_name,
      origin_meta,
      destination_meta,
      page_session_id,
      settedCurrency,
      source_entity,
      website_meta: {
        name: website_name,
        api_key: website_api_key,
      },
      total_price,
      currency,
    },
  });

  if (!bookingResult) {
    history.push(`/failed-booking/${page_session_id}`);
    return;
  }

  const status = _.get(bookingResult, "booking_result.status");
  if (status === "FA") {
    history.push(`/failed-booking/${page_session_id}`);
    return;
  }

  const reference = _.get(bookingResult, "booking_result.reference");
  const amount = _.get(bookingResult, "booking_result.payment_data.amount");
  currency = _.get(bookingResult, "booking_result.payment_data.currency");

  initPayment({
    customer_user_data,
    page_session_id,
    settedCurrency,
    dispatch,
    amount,
    source_entity,
    currency,
    reference,
    inbound_uid: flight.inbound,
    outbound_uid: flight.outbound,
    customer_stripe_id,
  });
}
